import axios from 'axios';

class NetworkService {
  getNetwork(slug) {
    let url = '/networks/' + slug;
    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getAll(query = null) {
    let url = 'networks/all';
    if (query) url += '?query=' + query;

    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getTrending(query = null) {
    let url = 'networks/trending_networks';
    if (query) url += '?query=' + query;

    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getUserData() {
    let url = 'my-data';

    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  deleteImage(network_slug, field, image_path) {
    // delete image
    let url = '/networks/delete/' + network_slug + '/image';

    var formData = new FormData();
    formData.append('network_slug', network_slug);
    formData.append('field', field);
    formData.append('image_path', image_path);

    return axios.post(url, formData).then(res => {
      return res;
    });
  }

  toggleLike(slug) {
    let url = 'networks/' + slug + '/toggle-like';
    return axios.post(url).then(resp => resp.data);
  }

  getFeaturedNetworks() {
    let url = 'networks/links-page';

    // unlike the other list methods here, the caller (Links.vue) needs to
    // tell a request failure apart from a legitimate empty result, so this
    // lets rejections propagate instead of resolving to false
    return axios.get(url).then(resp => resp.data);
  }

  // bypasses the /join-network page redirect used elsewhere - callers that
  // need to join several networks at once call this directly, concurrently,
  // per slug (see utils/networkJoinBatch.js)
  join(slug) {
    let url = 'networks/join/' + slug;
    return axios.post(url).then(resp => resp.data);
  }

  registerAndJoin(payload) {
    let url = 'networks/register-user';
    return axios.post(url, payload).then(resp => resp.data);
  }
}

// https://k94n.com/es6-modules-single-inst
export let networkservice = new NetworkService();
export default networkservice;
